import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {  faBars, faHouse, faSignOut, faUser } from "@fortawesome/free-solid-svg-icons";
import { Link, useNavigate } from "react-router-dom";
import { useUser } from "./context/UserContext";
import translation from '../Translation/Header.json'


export default function Header({ sidebarOpen, setSidebarOpen }) {

  const {user} = useUser();

  const navigate = useNavigate();

  const removeToken = () =>{
    localStorage.removeItem('admin-mobile-token')
    setTimeout(()=>{
      navigate('/')  
      window.location.reload()   
    },1000)
  }

  return (
    <nav className="bg-gray-100 px-5">
        <div className="w-full bg-blue-900 shadow-md rounded-lg mt-3 py-3 px-2">
      <div className="container mx-auto flex items-center justify-between py-2 px-4 md:px-6">
        {/* Left Section - Hamburger + Avatar */}
        <div className="flex items-center space-x-3 md:hidden ">
          {/* ☰ Hamburger Menu (visible on small screens) */}
          <button
            className="text-white text-2xl md:hidden focus:outline-none"
            onClick={() => setSidebarOpen(!sidebarOpen)}
          >
            <FontAwesomeIcon icon={faBars} />
          </button>
        </div>

        {/* Title - Responsive Center */}
        <h1 className="text-white text-lg md:text-xl hidden lg:block font-semibold tracking-wide text-center flex-1 md:flex-none">
           <FontAwesomeIcon icon={faUser} className="me-2"/> {translation.welcome} {user || "Admin"}
        </h1>

        {/* Right Section */}
        <div className="flex items-center space-x-3">
       
          {/* Logout Button */}
          <Link to='/login'>
          <button
            onClick={removeToken}
            className="bg-white text-indigo-600 font-semibold text-xs md:text-sm py-1 px-3 rounded hover:bg-gray-100 transition"
          >
            <FontAwesomeIcon icon={faSignOut} className="me-2"/>
            {translation.logout}
          </button>
          </Link>

         
        </div>
      </div>
  </div>

  <div className="flex justify-between items-center mt-3 pb-3">
    <Link to="/">
    <button className="py-2 px-3 text-white bg-blue-600 rounded-md"><FontAwesomeIcon icon={faHouse} className="me-2"/>{translation.home_page}</button>
    </Link>
    <button className="py-2 px-3 text-white bg-blue-600 rounded-md">Air</button>
  </div>
    </nav>
  );
}
